import { useQuery, useQueryClient } from "@tanstack/react-query";
import { collection, getDocs, onSnapshot } from "firebase/firestore";
import { useEffect } from "react";

import { db } from "@/config/firebase.ts";
import { AuthStore } from "@/store/useAuthStore.ts";

const fetchNotifications = async () => {
  const querySnapshot = await getDocs(collection(db, "notificationsMain"));

  return querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

export const useNotifications = () => {
  const queryClient = useQueryClient();
  const { setNotifications } = AuthStore();

  // Fetch initial notifications using TanStack Query
  const { data, isLoading, error } = useQuery({
    queryKey: ["notifications"],
    queryFn: fetchNotifications,
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
  });

  // Set up real-time listener for new notifications
  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "notificationsMain"),
      (querySnapshot) => {
        const notifications = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Count unread and read notifications
        const unread = notifications.filter(
          (notification: any) => !notification.seen,
        ).length;
        const read = notifications.filter(
          (notification: any) => notification.seen,
        ).length;

        // Update the global state in AuthStore
        // setNotifications({unread, read});
        setNotifications((prev) => ({
          ...prev, // Preserve existing properties
          unread: unread, // Update unread
          read: read, // Update read
        }));

        // Update TanStack Query cache
        queryClient.setQueryData(["notifications"], notifications);

        // console.log("Real-time notifications: ", notifications);
        // console.log("Real-time unread notifications: ", unread);
        // console.log("Real-time read notifications: ", read);
      },
    );

    return () => unsubscribe(); // Cleanup the listener on unmount
  }, [queryClient, setNotifications]);

  return { data, isLoading, error };
};
